import React, { useState, useContext, useEffect } from 'react';
import { Form, Input, Button, Checkbox, message } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../../utils/auth';
import { AuthContext } from '../../context/AuthContext';
import { mapOperationalError } from '../../utils/errorCatalog';
import { isCognitoMode } from '../../utils/authMode';
import { loginWithCognito } from '../../utils/cognitoAuth';
import { API_BASE_URL, FRONT_VERSION } from '../../config/endpoints';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { handleLogin } = useContext(AuthContext);
  const navigate = useNavigate();
  const [remember, setRemember] = useState(false);
  const [backendVersion, setBackendVersion] = useState('loading...');
  const [backendContractVersion, setBackendContractVersion] = useState('-');

  useEffect(() => {
    let cancelled = false;
    const loadVersion = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/version`);
        const payload = await response.json();
        if (!cancelled) {
          setBackendVersion(payload?.app_version || 'unknown');
          setBackendContractVersion(payload?.contract_version || '-');
        }
      } catch {
        if (!cancelled) {
          setBackendVersion('unavailable');
          setBackendContractVersion('-');
        }
      }
    };
    void loadVersion();
    return () => {
      cancelled = true;
    };
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const authResult = isCognitoMode()
        ? await loginWithCognito({ username: values.username, password: values.password })
        : await login(values.username, values.password);

      if (authResult?.challengeName === 'FORCE_CHANGE_PASSWORD') {
        navigate('/auth/force-change-password', { state: { remember } });
        return;
      }

      const accessToken = authResult.access_token || authResult.accessToken;
      const refreshToken = authResult.refresh_token || null;

      handleLogin({
        accessToken,
        refreshToken,
        remember,
      });
    } catch (error) {
      console.error('Falha no login', error);
      message.error(mapOperationalError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Login</h2>
      <Form onFinish={onFinish} className="login-form">
        <Form.Item name="username" rules={[{ required: true, message: 'Please input your username!' }]} className="login-form-item">
          <Input placeholder="Username" autocomplete="username" />
        </Form.Item>
        <Form.Item name="password"  rules={[{ required: true, message: 'Please input your password!' }]} className="login-form-item">
          <Input.Password placeholder="Password" autocomplete="current-password"/>
        </Form.Item>
        <Form.Item className="login-remember">
          <Checkbox checked={remember} onChange={e => setRemember(e.target.checked)}>Lembrar senha</Checkbox>
          <Link to="/auth/forgot-password">Esqueci minha senha</Link>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} className="login-button">
            Login
          </Button>
        </Form.Item>
      </Form>
      <div className="login-footer">
        Front v{FRONT_VERSION} | Back v{backendVersion} | Contract {backendContractVersion}
      </div>
    </div>
  );
};

export default Login;
